export default __webpack_public_path__ + "static/nx-badge-2025-eca94f822926d7e86e31812d14ab9a14.png";